export default "__VITE_ASSET__DrheXhbs__"